import DOMPurify from 'isomorphic-dompurify';
import {useMemo} from 'react';

export const useSanitizeString = (str?: string | null) => {
    return useMemo(() => {
        if (!str) {
            return '';
        }

        return DOMPurify.sanitize(str);
    }, [str]);
};
